/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Portal_Settings_HintInputs */

const cs_portals_portal_settings_hint = /** @type {(inputs: Portals_Portal_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav nabídky, bump a další volby specifické pro portál.`)
};

const en_portals_portal_settings_hint = /** @type {(inputs: Portals_Portal_Settings_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing status, bump, and other portal-specific options.`)
};

/**
* | output |
* | --- |
* | "Listing status, bump, and other portal-specific options." |
*
* @param {Portals_Portal_Settings_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_portal_settings_hint = /** @type {((inputs?: Portals_Portal_Settings_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Portal_Settings_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_portal_settings_hint(inputs)
	return cs_portals_portal_settings_hint(inputs)
});